module.exports = __webpack_public_path__ + "08ca1693528aadb53c849dea5f8f1087.pdf";